<style lang="scss" scoped>
.dropdown-item {
  &[disabled] {
    opacity: 0.5;
  }

  &:hover {
    cursor: pointer;

    &[disabled] {
      cursor: not-allowed;
    }
  }
}
</style>

<template>
  <td>
    <div ref="dropdown" class="dropdown dropleft" :class="{ show: show }">
      <button
        @click="show = !show"
        class="btn btn-secondary dropdown-toggle"
        type="button"
      >
        Aktionen
      </button>
      <div class="dropdown-menu" :class="{ show: show }">
        <div class="dropdown-item" @click="removeFromWaitingRoom">
          Aus dem Wartezimmer entfernen
        </div>
        <div class="dropdown-item" @click="showModal = true">
          An Moderator abgeben
        </div>
      </div>
    </div>
    <v-modal v-if="showModal" :show.sync="showModal">
      <h4 slot="header" class="title title-up">Moderator auswählen</h4>
      <dropdown-resource-selector
        v-model="moderator_id"
        :attribute="{
          resource: 'moderator/names',
          resourceProperty: 'name',
          valueProperty: 'id',
          filter: moderatorFilter,
          errors: []
        }"
        class="mb-3"
      ></dropdown-resource-selector>
      <div>
        <v-button
          type="button"
          class="btn-primary"
          @click.native="giveToModerator"
          >Speichern</v-button
        >
      </div>
    </v-modal>
  </td>
</template>

<script lang="babel">
import { catchOutsideClicks } from "@/js/bodyClick.js";
import { Modal } from "src/components/UIComponents";
import DropdownResourceSelector from "@/components/selector/DropdownResourceSelector";

export default {
    components: {
      'v-modal': Modal,
      DropdownResourceSelector
    },
    props: ['content', 'label', 'model'],
    data() {
      return {
        show: false,
        showModal: false,
        moderator_id: null,
      };
    },
    mounted() {
      catchOutsideClicks(this.$refs.dropdown, () => {
        this.show = false;
      });
    },
    methods: {
      giveToModerator() {
        if (!this.moderator_id) {
          return;
        }
        this.$http.post(`/api/v1/moderation/take/${this.model.id}`, { moderator_profile_id: this.moderator_id }).then(() => {
          this.$notify({
            group: "",
            title: `Dialog ${this.model.dialog_id} wurde an moderator mit ID ${this.moderator_id} gegeben`,
            type: "success"
          });
          this.$bus.$emit("waiting-dialogs-update");
        }).catch(error => {
          this.$notify({
            group: "",
            title: error.response.data.message,
            type: "error"
          });
        });

        this.showModal = false;
      },
      removeFromWaitingRoom() {
        this.$http.post(`/api/v1/moderation/remove-from-waiting/${this.model.id}`).then(() => {
          this.$notify({
            group: "",
            title: `Dialog ${this.model.dialog_id} wurde aus dem Wartezimmer entfernt`,
            type: "success"
          });
          this.$bus.$emit("waiting-dialogs-update");
        }).catch(error => {
          this.$notify({
            group: "",
            title: error.response.data.message,
            type: "error"
          });
        });
      }
    },
    computed: {
      moderatorFilter() {
        return [
          {
            name: 'in-chat-moderator',
          },
        ];
      }
    }
};
</script>
